import { PageRoute } from '../../../types/page.types';
import { DataRoomTab } from '../types/data-room.types';

export const dataRoomTabFromPathname = (pathname: string): DataRoomTab => {
  if (
    pathname === PageRoute.DATA_ROOM_ACTIVITY ||
    pathname.startsWith(`${PageRoute.DATA_ROOM_ACTIVITY}/`)
  ) {
    return DataRoomTab.ACTIVITY;
  }

  return DataRoomTab.WORKSPACES;
};
